"use client"

import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/20/solid"
import { useActivityDock } from "@src/providers/ActivityDockProvider"
import clsx from "clsx"
import Spinner from "./Spinner"

const ActivityToggle = () => {
  const { toggleDock, dockOpen, dockItems, status } = useActivityDock()

  if (dockItems.length === 0) return null

  return (
    <button
      type="button"
      onClick={toggleDock}
      className="group focus-visible:-outline-offset-2 flex w-full items-center justify-between gap-4 rounded-b-2xl px-3.5 py-3.5 confidential:hover:bg-gray-950 hover:bg-white focus-visible:outline-2 focus-visible:outline-gray-900"
    >
      <div className="flex items-center gap-2 confidential:text-gray-300 text-gray-700">
        <div className="flex-1 font-semibold text-sm">Activity</div>
        {status === "processing" && <Spinner size="sm" />}
      </div>

      <div
        className={clsx(
          "flex h-6 w-13 items-center justify-center rounded-lg transition-colors",
          dockOpen
            ? "bg-gray-900 confidential:bg-white confidential:text-gray-900 text-white"
            : "bg-gray-200 confidential:bg-gray-600 confidential:text-gray-200 text-gray-600"
        )}
      >
        {dockOpen ? (
          <ChevronDoubleLeftIcon className="size-5 shrink-0" />
        ) : (
          <ChevronDoubleRightIcon className="size-5 shrink-0" />
        )}
      </div>
    </button>
  )
}

export default ActivityToggle
